import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { Button, Checkbox, ConfirmationDialog, Icon, IconButton, Stack } from "@tm/components"
import { CostEstimationVoucher } from "../../../../../data/model"

type Props = {
    isSelected: boolean
    costEstimation: CostEstimationVoucher
    onDeleteCostEstimations(ids: Array<string>): void
    onOpenDetails(voucherId: string): void
    onSelectCostEstimation(costEstimationId: string): void
}

export function CostEstimationActions(props: Props) {
    const { costEstimation, onDeleteCostEstimations, onOpenDetails, onSelectCostEstimation } = props
    const { translateText } = useLocalization()
    const [showDeleteDialog, setShowDeleteDialog] = useState(false)

    function handleCostEstimationCheck() {
        onSelectCostEstimation(costEstimation.id)
    }

    function handleDeleteWarningConfirm() {
        onDeleteCostEstimations([costEstimation.id])
    }

    function handleDetailsClick() {
        onOpenDetails(costEstimation.id)
    }

    return (
        <Stack direction="row" gap={1} justifyContent="flex-end" alignItems="center">
            <Button variant="contained" onClick={handleDetailsClick}>
                {translateText(43)}
            </Button>
            <IconButton onClick={() => setShowDeleteDialog(true)} title={translateText(69)}>
                <Icon name="delete" />
            </IconButton>
            {showDeleteDialog && (
                <ConfirmationDialog
                    open
                    confirmationButtonText={translateText(585)}
                    cancelButtonText={translateText(584)}
                    onConfirm={handleDeleteWarningConfirm}
                    onCancel={() => setShowDeleteDialog(false)}
                >
                    {translateText(1752)}
                </ConfirmationDialog>
            )}

            <Checkbox checked={props.isSelected} onChange={handleCostEstimationCheck} />
        </Stack>
    )
}
